// extracted by mini-css-extract-plugin
export default {"login-form":"LoginForm_login-form__qOGFj"};